import { selectShutdownsFilter } from '../../features/filterNew/model/selectors';
import { fetchShutdowns } from '../api/queries/fetchShutdowns';
import {
  shutdowns_fetchError,
  shutdowns_fetchStart,
  shutdowns_fetchSuccess,
} from './types';

export const fetchShutdownsThunk = () => async (dispatch, getState) => {
  dispatch({ type: shutdowns_fetchStart });

  try {
    const {
      visible,
      filterChanged,
      chosenFilterId,
      chosenFilterName,
      ...filters
    } = selectShutdownsFilter(getState());

    const data = await fetchShutdowns(filters);

    dispatch({
      type: shutdowns_fetchSuccess,
      payload: { data, filters },
    });
  } catch (e) {
    dispatch({
      type: shutdowns_fetchError,
      payload: e,
    });
  }
};
